<template>
    <span class="typing">{{displayText}}</span>
</template>

<script>
    import { ref, toRefs, computed } from 'vue'
    export default {
        name: "KeyboardTyping",
        props: {
            text: [String, Array]
        },
        setup (props, context) {
            const { text } = toRefs(props)
            const displayText = ref('')

            let texts = Array.isArray(text.value) ? text.value : [text.value]
            let index = 0
            const cycle = () => { index = (index + 1) % texts.length }

            const deleteStutterCount = 5
            const deleteStutterTimeRange = [150, 250]
            const deleteSteadyTime = 60
            const typeStrokeTimeRange = [50, 200]
            const finishTypingWaitRange = [1500, 2500]
            const startTypingWaitRange = [1500, 2000]

            const getRandomNumInRange = (range) => {
                return Math.floor(range[0] + Math.random()*(range[1] - range[0]))
            }

            let currentState = 0
            const stateTransitions = [
                'typing',
                'finish_typing_wait',
                'delete_stutter',
                'delete_steady',
                'start_typing_wait'
            ]

            const callNext = () => {
                stateFunctions[stateTransitions[currentState]]()
            }

            const stateFunctions = {
                typing () {
                    setTimeout(() => {
                        displayText.value += texts[index][displayText.value.length]
                        if (displayText.value.length === texts[index].length) currentState ++
                        callNext()
                    }, getRandomNumInRange(typeStrokeTimeRange))
                },
                finish_typing_wait () {
                    setTimeout(() => {
                        currentState ++
                        callNext()
                    }, getRandomNumInRange(finishTypingWaitRange))
                },
                delete_stutter () {
                    setTimeout(() => {
                        displayText.value = displayText.value.slice(0, displayText.value.length - 1)
                        if (displayText.value.length < 1 || texts[index].length - displayText.value.length >= deleteStutterCount)
                            currentState ++
                        callNext()
                    }, getRandomNumInRange(deleteStutterTimeRange))
                },
                delete_steady () {
                    setTimeout(() => {
                        displayText.value = displayText.value.slice(0, displayText.value.length - 1)
                        if (displayText.value.length < 1) currentState ++
                        callNext()
                    }, deleteSteadyTime);
                },
                start_typing_wait () {
                    setTimeout(() => {
                        currentState = 0
                        cycle()
                        callNext()
                    }, startTypingWaitRange);
                }
            }

            callNext()

            return {
                displayText
            }
        } 
    }
</script>

<style scoped>
    .typing {
        padding-right: 1px;
        border-right: rgba(0, 0, 0, 1);
        animation-name: cursorblink;
        animation-duration: 530ms; /* 530 is standard cursor blinking speed */
        animation-iteration-count: infinite;
        animation-direction: alternate; 
    }

    @keyframes cursorblink {
        0% {
            border-right: 1px solid rgba(0, 0, 0, 1);
        }
        75% {
            border-right: 1px solid rgba(0, 0, 0, 1);
        }
        100% {
            border-right: 1px solid rgba(0, 0, 0, 0);
        }
    }
</style>